import {Injectable} from "@angular/core";
import {Haptics, NotificationType} from "@capacitor/haptics";
import {environment} from "src/app/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HapticsService {

  private isNative = environment.platform === 'native';

  error() {
    if (!this.isNative) return;

    Haptics.notification({ type: NotificationType.Error });
  }

  warning() {
    if (!this.isNative) return;

    Haptics.notification({ type: NotificationType.Warning });
  }
}
